const mutations = {
  setIndexAuctions(state, auctions) {
    return (state.indexAuctions = auctions);
  },
};

export default mutations;
